import { createContext, PropsWithChildren, useCallback, useContext, useState } from "react"
import { api } from "../../contracts";
import { LongExamResolution } from "../../contracts/longExamResolution/dto";
import { useCourse } from "../course";

type ContextLongExamResolutionData = {
    list: LongExamResolution[],
    getList: () => Promise<LongExamResolution[]>
}

const DEFAULT: ContextLongExamResolutionData = {
    list: [],
    getList: () => Promise.resolve([])
}

const LongExamResolutionContext = createContext(DEFAULT);

export const LongExamResolutionProvider = ({ children }: PropsWithChildren<any>) => {
    const { type } = useCourse();
    const [list, setList] = useState<LongExamResolution[]>([]);

    const getList = useCallback(async () => {
        const items = await api.longExamResolution.getList(type);
        setList(items);

        return items;
    }, [type]);

    return <LongExamResolutionContext.Provider
        value={{
            list,
            getList
        }}>
        {children}
    </LongExamResolutionContext.Provider>
}

export const useLongExamResolution = (): ContextLongExamResolutionData => {
    const context = useContext(LongExamResolutionContext);

    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }

    return context;
}